import PropTypes from 'prop-types';
import {
  USER_INTERFACE_FAVORITE_STAR_OUTLINE,
  LOGO_TRIPADVISOR,
} from '@bwoty-web/styleguide';
import cx from 'classnames';
import Rating from './rating';
import { sectionKeys } from '../sections/helper';
import './ratings.scss';

const Ratings = ({ ratings, labels, changeSection, className, siteSettings }) => {
  const hasTripAdvisorRating = ratings?.tripAdvisor?.numberOfReviews > 0;
  const hasGuestRating =
    ratings?.guests > 0 && ratings?.ratingDetails?.numberOfAnswers >= 10;

    const isTjareborg = siteSettings.siteId === 15;

  return (
    <div className={cx('gw-hotel-info-ratings', className)}>
      {hasGuestRating && (
        <Rating
          className={cx('gw-hotel-info-ratings__guest-rating', {
          'gw-hotel-info-ratings__guest-rating--tjareborg': isTjareborg,
           })}
          rating={Math.round(ratings.guests * 10) / 10}
          maxRating={5}
          linkText={labels?.guestRatingLinkLabel}
          iconPath={USER_INTERFACE_FAVORITE_STAR_OUTLINE}
          onClick={() => changeSection(`${sectionKeys.rating}:0`)}
        />
      )}
      {hasTripAdvisorRating && (
        <Rating
          className={cx('gw-hotel-info-ratings__tripadvisor', {
          'gw-hotel-info-ratings__tripadvisor--tjareborg': isTjareborg,
           })}
          rating={ratings.tripAdvisor.value}
          maxRating={5}
          linkText={labels?.tripadvisorText}
          iconPath={LOGO_TRIPADVISOR}
          onClick={() => changeSection(`${sectionKeys.rating}:1`)}
        />
      )}
    </div>
  );
};

Ratings.propTypes = {
  ratings: PropTypes.shape({
    tripAdvisor: PropTypes.shape(),
    ratingDetails: PropTypes.shape(),
    guests: PropTypes.number,
  }),
  labels: PropTypes.shape({
    guestRatingLinkLabel: PropTypes.string,
    tripadvisorText: PropTypes.string,
  }),
  changeSection: PropTypes.func.isRequired,
  className: PropTypes.string,
  siteSettings: PropTypes.shape({
    siteId: PropTypes.number,
  }).isRequired,
};

Ratings.defaultProps = {
  ratings: null,
  labels: null,
  className: null,
};

export default Ratings;
